import { captureException } from "@sentry/react";
import LoadingIndicator from "assets/svg/loading-indicator";
import PerformingPopouts from "components/campaigns/details/statistics/performing-popouts";
import { useEffect, useState } from "react";
import http from "services/https";
import { useReport } from "utils/reports";

export default function TopPopouts({ start, end, params = {} }) {
  const {
    report,
    isLoading: isReportLoading,
    isError: isReportError,
  } = useReport(start, end, {
    ...params,
    type: "top_popups",
  });

  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [popoutData, setPopoutData] = useState([]);
  useEffect(() => {
    setIsLoading(true);
    setIsError(false);

    if (isReportError) {
      setIsError(true);
      return;
    }

    if (typeof report !== "object" || isReportLoading) {
      setPopoutData([]);
      return;
    }

    let skip = false;

    (async () => {
      try {
        const data = await Promise.all(
          Object.entries(report)
            .sort(([, a], [, b]) => b.clicks - a.clicks)
            .slice(0, 2)
            .map(([popoutId, popoutReport]) =>
              (async () => {
                const req = await http.get(`popups/${popoutId}`);
                return {
                  popup: req.data.data,
                  report: popoutReport,
                };
              })()
            )
        );
        if (!skip) {
          setPopoutData(data);
        }
      } catch (e) {
        console.error("failed to load top popouts report", e);
        setIsError(true);
        captureException(e);
      } finally {
        setIsLoading(false);
      }
    })();

    return () => (skip = true);
  }, [report, isReportLoading, isReportError]);

  return (
    <>
      <p className="text-xl leading-7.5 tracking-normalwide">
        Top Performing Popouts
      </p>
      <div className="w-full mt-2">
        {isError ? (
          "Failed to load interaction data."
        ) : isLoading ? (
          <LoadingIndicator className="w-10 h-10 text-secondary" />
        ) : (
          <PerformingPopouts dataSource={popoutData} />
        )}
      </div>
    </>
  );
}
